(function () {
  const HOVER_MQ = window.matchMedia('(hover: hover) and (pointer: fine)');

  function positionPanel(trigger, panel) {
    panel.classList.add('is-fixed');
    panel.style.position = 'fixed';
    panel.style.zIndex = '99999';
    panel.style.right = 'auto';
    panel.style.bottom = 'auto';

    const panelWidth = Math.min(320, window.innerWidth - 24);
    panel.style.width = `${panelWidth}px`;

    const triggerRect = trigger.getBoundingClientRect();
    let left = triggerRect.left;
    const top = triggerRect.bottom + 8;

    if (left + panelWidth > window.innerWidth - 12) {
      left = window.innerWidth - panelWidth - 12;
    }

    panel.style.left = `${Math.max(12, left)}px`;
    panel.style.top = `${Math.max(12, top)}px`;
  }

  function resetPanelPosition(panel) {
    panel.classList.remove('is-fixed');
    panel.style.position = '';
    panel.style.zIndex = '';
    panel.style.left = '';
    panel.style.top = '';
    panel.style.width = '';
    panel.style.right = '';
    panel.style.bottom = '';
  }

  function initConditionInfo(root) {
    root.querySelectorAll('[data-condition-info]').forEach((info) => {
      if (info.dataset.conditionInfoInit === 'true') return;
      info.dataset.conditionInfoInit = 'true';

      const trigger = info.querySelector('[data-condition-trigger]');
      const panel = info.querySelector('[data-condition-panel]');
      if (!trigger || !panel) return;

      const badge = info.closest('.product-condition-badge--interactive');
      const card = info.closest('.card-wrapper');
      const hoverTarget = badge || info;
      let hideTimer;

      const hideNow = () => {
        clearTimeout(hideTimer);
        info.classList.remove('is-visible');
        trigger.setAttribute('aria-expanded', 'false');
        panel.hidden = true;
        resetPanelPosition(panel);
        if (badge) badge.classList.remove('is-tooltip-visible');
        if (card) card.classList.remove('has-condition-tooltip');
      };

      const show = () => {
        clearTimeout(hideTimer);
        info.classList.add('is-visible');
        trigger.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
        if (badge) badge.classList.add('is-tooltip-visible');
        if (card) card.classList.add('has-condition-tooltip');
        window.requestAnimationFrame(() => positionPanel(trigger, panel));
      };

      const hide = () => {
        hideTimer = window.setTimeout(hideNow, 120);
      };

      if (HOVER_MQ.matches) {
        hoverTarget.addEventListener('mouseenter', show);
        hoverTarget.addEventListener('mouseleave', hide);
        panel.addEventListener('mouseenter', show);
        panel.addEventListener('mouseleave', hide);
      }

      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (info.classList.contains('is-visible')) {
          hideNow();
        } else {
          show();
        }
      });

      document.addEventListener('click', (event) => {
        if (!info.contains(event.target) && !panel.contains(event.target)) {
          hideNow();
        }
      });

      window.addEventListener(
        'scroll',
        () => {
          if (info.classList.contains('is-visible')) {
            positionPanel(trigger, panel);
          }
        },
        true
      );

      window.addEventListener('resize', () => {
        if (info.classList.contains('is-visible')) {
          positionPanel(trigger, panel);
        } else {
          hideNow();
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initConditionInfo(document);
  });

  document.addEventListener('shopify:section:load', (event) => {
    initConditionInfo(event.target);
  });
})();
